import React from 'react'
import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useNavigate } from 'react-router-dom'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

export interface LogoutModalProps {
  onClose: () => void
  place: number
}

const LogoutModal: React.FC<LogoutModalProps> = ({ onClose }) => {
  const navigate = useNavigate()
  const { t } = useCustomTranslation()

  const modalActions = {
    primary: {
      name: t('common.logout'),
      onClick: () => {
        navigate('/logout')
        onClose()
      },
    },
    secondary: { name: t('common.cancel') },
  }

  return (
    <Dialog title={t('common.logout')} onClose={onClose} actions={modalActions} maxWidth="sm">
      {t('common.logoutForSure')}
    </Dialog>
  )
}

export default LogoutModal
